import Query from '../../../components/Report';

const query = (directory, subdomain) =>
    new Query('Search-urls-directory-details-chart', {
        directory,
        subdomain,
    });

export default query;
